import { FC, useState } from 'react'
import AnimateHeight from 'react-animate-height'
import MinusCircleSVg from '@/public/images/common/minus-circle-gray_v2.svg'
import PlusCircleSVg from '@/public/images/common/plus-circle-gray_v2.svg'
import styles from './index.module.scss'

type Props = {
  label: string
  text: string
  isOpen?: boolean
}

export const SubsidyFAQContent: FC<Props> = ({ label, text, isOpen = false }) => {
  const [isOpenDropDown, setIsOpenDropDown] = useState(isOpen)
  const toggleDropDown = () => {
    setIsOpenDropDown(!isOpenDropDown)
  }

  return (
    <div className={styles.container}>
      <div role='button' tabIndex={0} className={styles.content} onMouseDown={() => toggleDropDown()}>
        <div className={styles.textGroup}>
          <div className={styles.label}>{label}</div>
          <AnimateHeight duration={500} height={isOpenDropDown ? 'auto' : 0} easing='ease'>
            <div className={styles.text}>{text}</div>
          </AnimateHeight>
        </div>
        {isOpenDropDown ? <MinusCircleSVg viewBox='0 0 24 24' /> : <PlusCircleSVg viewBox='0 0 24 24' />}
      </div>
    </div>
  )
}
